export default __webpack_public_path__ + "static/media/spain.7ab20088.png";